import { clearAuthTokens } from './authTokenStore';
import { POST_LOGIN_REDIRECT_KEY } from '../config/routes';

/** Session keys written during auth / navigation (not device or learning prefs). */
const EXTRA_SESSION_KEYS = ['lastVisitedPage'];

/** Local keys that represent signed-in identity or onboarding gate. */
const LOCAL_AUTH_KEYS = ['userProfile', 'qnaread.onboardingDone'];

/**
 * Remove all client-side auth session data (tokens, redirects, cached profile).
 * HttpOnly API cookies are cleared via POST /auth/logout with credentials.
 */
export function clearAllClientAuthState() {
  clearAuthTokens();
  try {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    EXTRA_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
    LOCAL_AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
    // Legacy token keys if any remained in sessionStorage
    sessionStorage.removeItem('qnaread.accessToken');
    sessionStorage.removeItem('qnaread.refreshToken');
  } catch {
    /* storage blocked */
  }
}
